import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';
import { AlertCircle, CheckCircle2, X } from 'lucide-react';

type Notify = (message: string) => void;
const ToastContext = createContext<Notify>(() => undefined);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [message, setMessage] = useState('');
  const notify = useCallback((next: string) => {
    setMessage(next);
    window.setTimeout(() => setMessage(''), 3000);
  }, []);
  const value = useMemo(() => notify, [notify]);
  const isError = /error|failed|unexpected|invalid|not found|cannot|unable|permission|required/i.test(message);
  return <ToastContext.Provider value={value}>
    {children}
    <div className={`toast ${message ? 'show' : ''} ${isError?'toast-error':''}`} role={isError?'alert':'status'}>
      {isError?<AlertCircle size={20}/>:<CheckCircle2 size={20} />}
      <div><strong>{message || 'Done'}</strong><small>{isError?'Please review the message and try again.':'Action completed successfully.'}</small></div>
      <button onClick={() => setMessage('')} aria-label="Close notification"><X size={15} /></button>
    </div>
  </ToastContext.Provider>;
}

export const useToast = () => useContext(ToastContext);
